import React from 'react';
import { Polar } from 'react-chartjs-2';
const chartColor = '#FFFFFF';

const data = (canvas, vals, data) => {

    return {
        labels: vals,
        datasets: [{
            label: "Department",
            
            backgroundColor: [
                '#ED3D63',
                '#223CCF',
                '#161B7F',
                "#8D3FD0",
                "#0683D7",
                '#FCE786',
                '#D22D16',
                "#36A1D4",
                "#E67235"
                ],
                hoverBackgroundColor: 'gray',
                data: data
        }]
    }
};
const options = {
    maintainAspectRatio: false,
    legend: {
        display: true
    },
    
    tooltips: {
        bodySpacing: 4,
        mode:"nearest",
        intersect: 0,
        position:"nearest",
        xPadding:10,
        yPadding:10,
        caretPadding:10
    },
    responsive: 1,
    scales: {
        yAxes: [{
            display:0,
            ticks: {
                display: false
            },
            gridLines: {
                zeroLineColor: "transparent",
                drawTicks: false,
                display: false,
                drawBorder: false
            }
        }],
        xAxes: [{
            display:0,
            ticks: {
                display: false
            },
            gridLines: {
                zeroLineColor: "transparent",
                drawTicks: false,
                display: false,
                drawBorder: false
            }
        }],
        
        
    },
    layout:{
        padding:{left:0,right:0,top:15,bottom:15}
    }
};

class Chart extends React.Component{
    constructor(props){
        super(props);
        this.state ={
            label:[0],
            datas:[0]
        }
    }

    componentDidMount(){
        this.setState({
            label:this.props.label,
            datas:this.props.data
        })
    }

    componentDidUpdate(prevProps){
        if(this.props.label !== prevProps.label)
        {
            this.setState({
                label:this.props.label,
                datas:this.props.data
            })

        }

    }

    render(){
        let { label, datas } = this.state;
        return(
            <Polar
                data={(canvas)=>data(canvas, label, datas)} 
                height='300px'
                options={{}} 
            />
        );
    }
}

export default Chart;